import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { QueryClient, QueryClientProvider } from 'react-query';
import Routes from './pages/Routes';
import { reactPlugin } from './utils/app-insights-utils';
import theme from './styles/chakra/theme';
import { GlobalContextProvider } from './components/GlobalContextProvider/GlobalContextProvider';
import './styles/style-bundle.scss';
import { AppContextProvider } from './components/AppContextProvider/AppContextProvider';
import AuthProvider from './components/AuthProvider';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <AppContextProvider>
        <AuthProvider>
          <AppInsightsContext.Provider value={reactPlugin}>
            <QueryClientProvider client={queryClient}>
              <GlobalContextProvider>
                <Router>
                  <Routes />
                </Router>
              </GlobalContextProvider>
            </QueryClientProvider>
          </AppInsightsContext.Provider>
        </AuthProvider>
      </AppContextProvider>
    </ChakraProvider>
  </React.StrictMode>
);
